export const getTiModuleState = (state) => state.CustomTIModuleReducer;